import {authError} from './CareerAuth';

// The existing SMS reset API supports Turkish mobile numbers only. Do not send
// foreign numbers through its legacy Turkish-number normalizer.
export function resetPhone(value){
 const raw=String(value||'').trim();
 if(!/^(?:\+|00)?[\d\s().-]+$/.test(raw))return null;
 let digits=raw.replace(/\D/g,'');
 if(raw.startsWith('+')||digits.startsWith('00')){
  if(digits.startsWith('00'))digits=digits.slice(2);
  if(!digits.startsWith('90'))return null;
  digits=digits.slice(2);
 }else if(digits.length===12&&digits.startsWith('90'))digits=digits.slice(2);
 else if(digits.length===11&&digits.startsWith('0'))digits=digits.slice(1);
 return /^5\d{9}$/.test(digits)?digits:null;
}

export async function passwordResetError(response,t){
 if(response.status===429)return t('authTryLater');
 if(response.status>=500)return t('authNetworkError');
 const fallback=response.clone();let text='';
 try{text=await response.text();}catch{return t('error');}
 const value=text.toLocaleLowerCase('tr-TR');let data;
 try{data=JSON.parse(text);}catch{data=null;}
 if(response.status===404)return t('resetAccountMissing');
 if(value.includes('birden fazla kullanıcı'))return t('resetPhoneAmbiguous');
 if(data?.code==='phoneConfirmationRequired'||value.includes('telefon numaranız doğrulanmadığı'))return t('resetPhoneUnverified');
 if(value.includes('e-posta adresiniz doğrulanmadığı'))return t('resetEmailUnverified');
 if(['codeExpired','resetCodeExpired'].includes(data?.code)||value.includes('kodun süresi dolmuş'))return t('authCodeExpired');
 if(value.includes('kod hakkınız doldu')||value.includes('geçerli bir şifre sıfırlama kodu bulunamadı'))return t('resetRequestAgain');
 if(['invalidCode','invalidResetCode'].includes(data?.code)||value.includes('kod yanlış'))return t('resetInvalidCode');
 if(value.includes('yeni şifre eski şifreniz ile aynı'))return t('resetPasswordSame');
 return authError(fallback,t);
}
